import React from 'react';

import { Margin } from '@ovotech/nebula';
import { NoAppBanner } from '@/src/components/Banners/GetBeyondBanner/NoAppBanner';
import { NoDDBanner } from '@/src/components/Banners/GetBeyondBanner/NoDDBanner';
import {
  IneligibleBanner,
  NoDDOrSMBanner,
  NoSMBanner,
} from '@/src/components/Banners/GetBeyondBanner/WhiteBannerVariations';
import {
  BeyondAccountStatus,
  BeyondAccountStatusGraphqlResponse,
} from '@/src/types/Response';

enum BannerType {
  NO_APP = 'NO_APP',
  SMART_METER_NO_DIRECT_DEBIT = 'SMART_METER_NO_DIRECT_DEBIT',
  DIRECT_DEBIT_NO_SMART_METER = 'DIRECT_DEBIT_NO_SMART_METER',
  NO_DIRECT_DEBIT_AND_NO_SMART_METER = 'NO_DIRECT_DEBIT_AND_NO_SMART_METER',
  INELIGIBLE = 'INELIGIBLE',
}

export const getBeyondBannerType = ({
  beyondAccountStatus,
}: BeyondAccountStatusGraphqlResponse): BannerType | null => {
  const { status, directDebitStatus, smartMeterStatus } = beyondAccountStatus;

  const hasSmartMeter = smartMeterStatus === 'ACTIVE';
  const hasDirectDebit = directDebitStatus === 'ACTIVE';

  if (
    hasDirectDebit &&
    hasSmartMeter &&
    status !== BeyondAccountStatus.Ineligible
  ) {
    return BannerType.NO_APP;
  }

  if (status === BeyondAccountStatus.Ineligible) return BannerType.INELIGIBLE;

  if (!hasSmartMeter && !hasDirectDebit) {
    return BannerType.NO_DIRECT_DEBIT_AND_NO_SMART_METER;
  }

  if (!hasDirectDebit) {
    return BannerType.SMART_METER_NO_DIRECT_DEBIT;
  }

  if (!hasSmartMeter) {
    return BannerType.DIRECT_DEBIT_NO_SMART_METER;
  }

  return null;
};

const BannerMap = {
  [BannerType.NO_APP]: NoAppBanner,
  [BannerType.SMART_METER_NO_DIRECT_DEBIT]: NoDDBanner,
  [BannerType.DIRECT_DEBIT_NO_SMART_METER]: NoSMBanner,
  [BannerType.NO_DIRECT_DEBIT_AND_NO_SMART_METER]: NoDDOrSMBanner,
  [BannerType.INELIGIBLE]: IneligibleBanner,
};

export const GetBeyondBanner = (
  beyondAccountStatusResponse: BeyondAccountStatusGraphqlResponse,
) => {
  const bannerType = getBeyondBannerType(beyondAccountStatusResponse);

  if (!bannerType) return null;

  const Banner = BannerMap[bannerType];

  return (
    <Margin top={6}>
      <Banner />
    </Margin>
  );
};
